import { ApolloClient } from '@apollo/client'

import { Store } from 'Services/Store'

export enum SharedService {
  ApolloClient = 'apolloClient',
  Store = 'store',
}

const SERVICES: Record<string, any> = {}

function getService<T = any>(service: SharedService): T {
  const instance = SERVICES[service]
  if (!instance) throw new Error(`${service} not found in Shared`)
  return instance as T
}

// Apollo Client
function setApolloClient(client: ApolloClient<any>) {
  SERVICES[SharedService.ApolloClient] = client
}
function getApolloClient() {
  return getService<ApolloClient<any>>(SharedService.ApolloClient)
}

// Store
function setStore(store: Store) {
  SERVICES[SharedService.Store] = store
}
function getStore() {
  return getService<Store>(SharedService.Store)
}
const Shared = { setApolloClient, getApolloClient, setStore, getStore }

export default Shared
